import Tippy from "@tippyjs/react";
import React from "react";
import TypesOfLocationEnum from "./typesOfLocationEnum";

const LocationSettingsItem = (props) => {
    const factory = () => {
        switch (props.path) {
            case TypesOfLocationEnum.CUSTOM_EXAM: return "Evaluation"
            case TypesOfLocationEnum.SETTINGS: return "Details And Evaluation"
            case TypesOfLocationEnum.PDF: return "PDF"
            case TypesOfLocationEnum.SPLIT_SCREEN: return "Split Screen"
            case TypesOfLocationEnum.ERROR: return "Error"
            case TypesOfLocationEnum.FRONTEND: return "Render Frontend"

            default: return "Blank Tab"
        }
    }

    return (
        <>
            <Tippy content={factory()} placement="top">
                <div className="location-settings-hover-item" draggable="true" onClick={() => {
                    props.updateCurrentViewer(props.path)
                }}>
                    { props.svgOne }
                </div>
            </Tippy>
        </>
    );
}

export default LocationSettingsItem;